export default ["M8 2a1 1 0 01.928.629l3.992 9.979a1 1 0 11-1.857.742l-.94-2.35H5.877l-.94 2.35a1 1 0 11-1.857-.742l3.992-9.98A1 1 0 018 2zM6.677 9h2.646L8 5.693 6.677 9z"];
//# sourceMappingURL=font.js.map